import { FormActionFrameworkStep, registerStep } from '../step';
import { resolveTemplate } from '../template';
import { findSurveyQuestion, resolveFieldName } from './populateDropdown';
export class EnableDisableFieldStep extends FormActionFrameworkStep {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'enableDisableField'
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                fieldName: '',
                action: 'disable',
            }
        });
    }
    async execute(context) {
        const fieldName = resolveFieldName({
            fieldName: String(resolveTemplate(this.config.fieldName ?? '', context) ?? ''),
        });
        if (!fieldName) {
            context.log('[enableDisableField] missing fieldName — skipped');
            return context;
        }
        const model = context.form;
        const question = findSurveyQuestion(model, fieldName);
        if (!question) {
            context.log(`[enableDisableField] question not found for fieldName="${fieldName}" — skipped`);
            return context;
        }
        const action = normalizeAction(this.config.action);
        const currentlyReadOnly = !!question.readOnly;
        let nextReadOnly;
        if (action === 'toggle') {
            nextReadOnly = !currentlyReadOnly;
        }
        else if (action === 'enable') {
            nextReadOnly = false;
        }
        else {
            nextReadOnly = true;
        }
        question.readOnly = nextReadOnly;
        if ('enable' in question) {
            question.enable = !nextReadOnly;
        }
        context.log(`[enableDisableField] ${fieldName} action=${action} readOnly=${nextReadOnly}`);
        return context;
    }
    showStepForm(container) {
        container.innerHTML = '';
    }
}
function normalizeAction(action) {
    const s = typeof action === 'string' ? action.toLowerCase() : '';
    if (s === 'enable' || s === 'disable' || s === 'toggle') {
        return s;
    }
    return 'disable';
}
registerStep('enableDisableField', EnableDisableFieldStep);
